import { SHOP_JOBS_PATH } from '../../Providers/shopAuth';

export const SHOP_JOBS_LAND = SHOP_JOBS_PATH;

export const SHOP_SIGNUP_LINK_ERROR =
  'This invite link could not be checked. Confirm you are on the Glass shop host and retry.';

/**
 * registerShopUser → sign-in → force claims onto the token → /app/jobs.
 * Without the refresh, a brand-new shop user was bounced to /login.
 */
export async function finishShopInviteSignup({ register, signIn, land }) {
  await register();
  const cred = await signIn();
  const user = cred?.user;
  if (user?.getIdToken) {
    await user.getIdToken(true);
  }
  land(SHOP_JOBS_LAND);
}

export function shopExistenceNextPath(exists) {
  return exists ? null : '/login';
}
